export enum FrontOrigin {
    PORTAL = 'PORTAL',
    FLEET = 'FLEET',
    MOBILE_V1 = 'MOBILE_V1',
    MOBILE_V2 = 'MOBILE_V2',
    PAYNOW = 'PAYNOW',
    PAYNOW_V3 = 'PAYNOW_V3'
}
